import Acl from 'browser-acl'

const acl = new Acl()

/**
 Пользователи - никто
 Клиники, врачи и услуги - admins
 Агенты - m.chistova
 Реестры - никто
 Блог - никто
 Фотопоток - admins
 Что мы лечим - никто
 ЛК МедПрофи - m.chistova
*/
acl.rule(['create', 'update', 'show'], 'User', (user) => user.isGod())
acl.rule(['login_to_account'], 'User', (user) => user.isGod() && user.canLoginToAccount())
acl.rule(['create', 'update', 'delete', 'show'], 'Symptom', (user) => user.isGod())
acl.rule(['create', 'update', 'delete', 'show'], 'Disease', (user) => user.isGod())
acl.rule(['create', 'update', 'delete', 'show'], 'Procedure', (user) => user.isGod())
acl.rule(['create', 'update', 'delete', 'show'], 'Post', (user) => user.isGod())
acl.rule(['create', 'update', 'delete', 'show'], 'Lecture', (user) => user.isGod())
acl.rule(['show'], 'Appointment', (user) => user.isGod())
acl.rule(['show'], 'Payment', (user) => user.isGod())
acl.rule(['show'], 'SearchTerm', (user) => user.isGod())
acl.rule(['show'], 'UserFileHistory', (user) => user.isGod())
acl.rule(['show'], 'MedicalCardHistory', (user) => user.isGod())

acl.rule(['create', 'update', 'delete', 'show'], 'Clinic', (user) => user.isGod())
acl.rule(['create', 'update', 'delete', 'show'], 'Doctor', (user) => user.isAdmin())
acl.rule(['create', 'update', 'delete', 'show'], 'Service', (user) => user.isAdmin())
acl.rule(['create', 'update', 'delete', 'show'], 'ServiceCategory', (user) => user.isAdmin())
acl.rule(['create', 'update', 'delete', 'show'], 'Speciality', (user) => user.isAdmin())
acl.rule(['create', 'update', 'delete', 'show'], 'Examination', (user) => user.isAdmin())
acl.rule(['create', 'update', 'delete', 'show'], 'HouseCallMap', (user) => user.isAdmin())
acl.rule(['create', 'update', 'show'], 'Photo', (user) => user.isAdmin())
acl.rule(['create', 'update', 'delete', 'show'], 'Clinic', (user) => user.isAdmin())
acl.rule(['create', 'update', 'delete', 'show'], 'Jobs', (user) => user.isHR())
acl.rule(['create', 'update', 'delete', 'show'], 'Pages', (user) => user.isAdmin())
acl.rule(['create', 'show'], 'Cme', (user) => (user.isDoctor() || user.isHHO))

acl.rule(['show'], 'Messengers', (user) => user.isAdmin())

acl.rule(['create', 'update', 'delete', 'show'], 'Collab', (user) => user.isAgentsAdmin())
acl.rule(['login_to_account'], 'Collab', (user) => user.isAgentsAdmin() && user.canLoginToAccount())
acl.rule(['create', 'update', 'delete', 'show'], 'Agent', (user) => user.isAgentsAdmin())
acl.rule(['show_calendar'], 'Doctor', (user) => (user.isDoctor() || user.isHHO()))

acl.rule(['show'], 'FunctionalTestingReport', (user) => (user.isDoctor() || user.isHHO()))

acl.rule(['refund'], 'Transaction', (user) => user.isGod())
acl.rule(['unbind'], 'BankCard', (user) => user.isGod())

acl.rule(['show'], 'InformerNotifications', (user) => user.isGod())

export default acl
